<template>
  <div class="stock__report">
    <!-- <ReportFormat :records="reports_data" :is_form_show="false" @download_excel_report="exportExcel">
      <template #record-table>
        <template>
          <vs-th>#</vs-th>
          <vs-th>Product Name</vs-th>
          <vs-th>Category Name</vs-th>
          <vs-th>Sales Price ($)</vs-th>
          <vs-th>Weight Per Package</vs-th>
          <vs-th>Quantity</vs-th>
          <vs-th>Weight Type</vs-th>
        </template>

        <template ref="tableBody">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in reports_data">
            <vs-td>{{ i + 1 }}</vs-td>
            <vs-td>{{ tr.product_name }}</vs-td>
            <vs-td>{{ tr.category.category_name }}</vs-td>
            <vs-td>$ {{ tr.sales_price | currencyFilter }}</vs-td>
            <vs-td>{{ (tr.categoryId == categories.FLOWER || tr.categoryId == categories.SHAKE ? tr.quantity : tr.weight_per_package) | weightFilter }}</vs-td>
            <vs-td>{{ (tr.categoryId == categories.FLOWER || tr.categoryId == categories.SHAKE ? 0 : tr.quantity) | weightFilter }}</vs-td>
            <vs-td>{{ tr.weight_type }}</vs-td>
          </vs-tr>
        </template>
      </template>
    </ReportFormat> -->

    <div class="report_formaty">
      <vs-card id="data-loading">
        <vs-table id="table-loading" class="vs-con-loading__container" stripe :sst="true" maxHeight="500px" :data="reports_data">
          <template slot="header">
            <!-- TABLE ACTION ROW -->
            <div class="flex flex-wrap justify-between items-center w-full my-3">
              <div class="table_title font-bold text-xl">Records Table</div>

              <div class="inline-flex">
                <vs-button color="dark" class="mr-2" type="filled" @click="exportExcel">Excel</vs-button>
                <vx-tooltip class="cursor-pointer" text="Re-Order/Toggle Columns">
                  <vs-dropdown vs-custom-content vs-trigger-click>
                    <div class="px-10 py-3 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium">
                      <span class="mr-2">Columns</span>
                      <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>
                    <vs-dropdown-menu>
                      <div class="vs-list">
                        <template>
                          <div
                            :class="{ 'item-active': column.show }"
                            @click="column.show = !column.show"
                            @dragover.prevent
                            @dragenter.prevent
                            @drop="onDrop($event, i)"
                            draggable
                            v-for="(column, i) in columns"
                            @dragstart="startDrag($event, column, i)"
                            :key="i"
                            class="vs-list--item cursor-pointer"
                          >
                            <div class="list-titles">
                              <div class="vs-list--title">
                                {{ column.name }}
                              </div>
                            </div>
                          </div>
                        </template>
                      </div>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </vx-tooltip>
              </div>
            </div>
          </template>

          <template slot="thead">
            <vs-th>#</vs-th>
            <vs-th v-show="column.show" v-for="(column, i) in columns" :key="i">{{ column.name }}</vs-th>
          </template>

          <template slot-scope="{ data }" ref="tableBody">
            <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
              <vs-td>{{ i + 1 }}</vs-td>
              <vs-td v-show="column.show" v-for="(column, i) in columns" :key="i">{{ column.cb(tr) }}</vs-td>

              <!-- <vs-td>{{ tr.product_name }}</vs-td>
              <vs-td>{{ tr.category.category_name }}</vs-td>
              <vs-td>$ {{ tr.sales_price | currencyFilter }}</vs-td>
              <vs-td>{{ (tr.categoryId == categories.FLOWER || tr.categoryId == categories.SHAKE ? tr.quantity : tr.weight_per_package) | weightFilter }}</vs-td>
              <vs-td>{{ (tr.categoryId == categories.FLOWER || tr.categoryId == categories.SHAKE ? 0 : tr.quantity) | weightFilter }}</vs-td>
              <vs-td>{{ tr.weight_type }}</vs-td> -->
            </vs-tr>
          </template>
        </vs-table>
      </vs-card>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx'
import draggable from 'vuedraggable'

import { mapActions, mapState, mapMutations } from 'vuex'
import { paymentMixins } from '@/utils/paymentTypes'
import { weightMixins } from '@/utils/weightType'
import ReportFormat from '@/views/reports/components/ReportFormat.vue'

export default {
  name: 'StockReport',

  components: {
    ReportFormat,
    draggable
  },

  data() {
    return {
      page: 1,
      limit: 0,
      search: '',
      loading: false,
      columns: [
        {
          name: 'Product Name',
          cb: tr => tr.product_name,
          show: true
        },
        {
          name: 'Category',
          cb: tr => tr.category.category_name,
          show: true
        },
        {
          name: 'Batch #',
          cb: tr => tr.batch && tr.batch.batch_number,
          show: true
        },
        {
          name: 'Batch Name',
          cb: tr => tr.batch && tr.batch.batch_name,
          show: true
        },
        {
          name: 'THC',
          cb: tr => tr.thc,
          show: true
        },
        {
          name: 'CBD',
          cb: tr => tr.cbd,
          show: true
        },
        {
          name: 'Terpenoid',
          cb: tr => tr.terpenoid_potency,
          show: true
        },
        // {
        //   name: 'Location',
        //   cb: (tr) => tr.category.category_name,
        //   show: true
        // },
        {
          name: 'Sales Price',
          cb: tr => paymentMixins.methods.mathRound(tr.sales_price, 2),
          show: true
        },
        {
          name: 'Weight Type',
          cb: tr => tr.weight_type,
          show: true
        },
        {
          name: 'Quantity',
          // eslint-disable-next-line no-confusing-arrow
          cb: tr => weightMixins.methods.mathRound(tr.categoryId === this.categories.FLOWER || tr.categoryId === this.categories.SHAKE ? tr.weight_per_package : tr.quantity, 3),
          show: true
        },
        {
          name: 'Weight Per Package',
          // eslint-disable-next-line no-confusing-arrow
          cb: tr => weightMixins.methods.mathRound(tr.categoryId === this.categories.FLOWER || tr.categoryId === this.categories.SHAKE ? tr.quantity : tr.weight_per_package, 3),
          show: true
        },
        {
          name: 'Audit',
          cb: () => '',
          show: true
        }
      ]
    }
  },

  mixins: [weightMixins, paymentMixins],

  async mounted() {
    await this.get_stock_report()
  },

  methods: {
    ...mapActions('report', { fetch_stock_report: 'getStockReport' }),
    ...mapMutations('report', { set_state: 'SET_STATE' }),
    onDrop(e, i) {
      const oi = e.dataTransfer.getData('itemID')
      const item = this.columns.splice(oi, 1)
      this.columns.splice(i, 0, item[0])
    },
    startDrag(e, item, index) {
      e.dataTransfer.dropEffect = 'move'
      e.dataTransfer.effectAllowed = 'move'
      e.dataTransfer.setData('itemID', index)
    },

    async get_stock_report() {
      this.loading = true
      const payload = {
        page: this.page,
        limit: this.limit,
        search: this.search
      }

      this.$store
        .dispatch('report/getStockReport', payload)
        .then(() => {
          this.loading = false
        })
        .catch(err => {
          const { message } = err
          this.loading = false
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    async exportExcel() {
      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet(
        this.reports_data.reduce((acc, item, index) => {
          if (!(item.weight_per_package === 0 && item.quantity === 0)) {
            acc.push({
              '#': index + 1,
              ...this.columns.reduce((obj, column) => {
                if (column.show) {
                  obj[column.name] = column.cb(item)
                }
                return obj
              }, {})
              // 'Product Name': item.product_name,
              // 'Category Name': item.category.category_name,
              // 'Sales Price ($)': `$ ${item.sales_price}`,
              // 'Weight Per Package': weightMixins.methods.mathRound(
              //   Number(item.categoryId === this.categories.FLOWER || item.categoryId === this.categories.SHAKE ? item.quantity : item.weight_per_package),
              //   3
              // ),
              // Quantity: weightMixins.methods.mathRound(Number(item.categoryId === this.categories.FLOWER || item.categoryId === this.categories.SHAKE ? 0 : item.quantity), 3),
              // 'Weight Type': item.weight_type
            })
          }

          return acc
        }, [])
      )
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1')
      XLSX.writeFile(wb, 'Stock Report.xlsx')
    }
  },

  computed: {
    ...mapState('product', ['categories']),
    ...mapState('report', ['reports_data', 'total', 'FilteredCount']),
    computedColumns: {
      get() {
        return this.columns
      },
      set(items) {
        this.columns = items
      }
    }
  },

  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#table-loading',
          scale: 0.45,
          color: 'primary'
        })
      } else {
        this.$vs.loading.close('#table-loading > .con-vs-loading')
      }
    }
  },
  filters: {
    //weightFilter rounded conversation
    weightFilter(value) {
      return weightMixins.methods.mathRound(Number(value), 3)
    },

    // currencyFilter rounded to 2 point
    currencyFilter(value) {
      return paymentMixins.methods.mathRound(Number(value), 2)
    }
  },
  async beforeDestroy() {
    await this.set_state({ action: 'reports_data', data: [] })
  }
}
</script>

<style lang="scss">
.con-vs-dropdown--menu {
  &.vs-dropdown-menu {
    width: 230px;
  }
  .vs-list--item[draggable='true'] {
    border-radius: 10px;
    margin: 2px 0 2px 0;
    .list-titles {
      margin-left: 5px;
    }
    &.item-active {
      background-color: rgba(var(--vs-primary), 1);
      color: #f8f8f8;
    }
  }
}
</style>
